import React from 'react'
import OddBatchPage from './OddBatchPage'
import '../styles/index.scss'

const OddBatchContainer = () => {
    return (
        <div className='OddBatchContainer'>
            <OddBatchPage />
        </div>
    )
}

export default OddBatchContainer